function daysAgoUtc(days, { hour = 14, minute = 22 } = {}) {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - days);
  d.setUTCHours(hour, minute, 0, 0);
  return d.toISOString().replace('Z', '');
}

function daysFromNowDateOnly(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/** Sample sync events shaped like `/core/users/feeds/events`. */
export function getDummyEvents() {
  return [
    {
      id: 9001,
      event_type: 'Invoice Created',
      status_code: 201,
      create_date: daysAgoUtc(2, { hour: 15, minute: 12 }),
      msg: 'Invoice successfully created in QuickBooks.',
      target_customer: 'Acme Robotics',
      target_type: 'Invoice',
      target_doc_num: 'INV-10482',
      target_doc_id: '145',
      target_status: 'Pending',
      total_amount: '4850.00',
      source_system: 'hubspot',
      target_system: 'quickbooks',
      object_id: 'hs-deal-48291',
      sent_to_user: true,
      sent_to_customer: false,
      event_data: {
        propertyName: 'dealstage',
        propertyValue: 'closedwon',
        subscriptionType: 'deal.propertyChange',
        changeSource: 'CRM_UI',
        occurredAt: Date.now() - 2 * 24 * 60 * 60 * 1000,
      },
      stream_data: {
        company_data: { name: 'Acme Robotics' },
        deal_data: {
          dealname: 'Acme Annual Platform',
          terms: 'Net 30',
          payment_method: 'ACH',
        },
        inv_data: { hs_number: 'INV-10482' },
        line_items: [
          { name: 'Platform License — Annual', amount: '4200.00' },
          { name: 'Onboarding Services', amount: '650.00' },
        ],
      },
    },
    {
      id: 9002,
      event_type: 'Journal Entry Created',
      status_code: 201,
      create_date: daysAgoUtc(5, { hour: 11, minute: 4 }),
      msg: 'Journal entry posted to Xero.',
      target_customer: 'Northwind Labs',
      target_type: 'JournalEntry',
      target_doc_num: 'JE-392',
      target_doc_id: 'je-392',
      target_status: 'Posted',
      total_amount: '1250.00',
      source_system: 'salesforce',
      target_system: 'xero',
      object_id: 'sf-opp-77102',
      sent_to_user: true,
      sent_to_customer: false,
      event_data: {
        propertyName: 'StageName',
        propertyValue: 'Closed Won',
        subscriptionType: 'opportunity.update',
        changeSource: 'API',
        occurredAt: Date.now() - 5 * 24 * 60 * 60 * 1000,
      },
      stream_data: {
        company_data: { name: 'Northwind Labs' },
        deal_data: {
          dealname: 'Northwind Expansion — Year 2',
          terms: 'Net 15',
          payment_method: 'Wire',
        },
        line_items: [
          { name: 'Deferred Revenue Recognition', amount: '1250.00' },
        ],
      },
    },
    {
      id: 9003,
      event_type: 'Invoice Created',
      status_code: 400,
      create_date: daysAgoUtc(1, { hour: 18, minute: 41 }),
      msg: 'Failed to create invoice: Customer email is required.',
      target_customer: 'Brightside Consulting',
      target_type: 'Invoice',
      target_doc_num: null,
      target_doc_id: null,
      target_status: null,
      total_amount: '2100.00',
      source_system: 'hubspot',
      target_system: 'quickbooks',
      object_id: 'hs-deal-55110',
      sent_to_user: true,
      sent_to_customer: false,
      resolution: null,
      event_data: {
        propertyName: 'dealstage',
        propertyValue: 'closedwon',
        subscriptionType: 'deal.propertyChange',
        changeSource: 'CRM_UI',
        occurredAt: Date.now() - 1 * 24 * 60 * 60 * 1000,
      },
      stream_data: {
        company_data: { name: 'Brightside Consulting' },
        deal_data: {
          dealname: 'Brightside Q3 Renewal',
          terms: 'Net 30',
        },
        line_items: [
          { name: 'Professional Services Retainer', amount: '2100.00' },
        ],
      },
    },
    {
      id: 9004,
      event_type: 'Invoice Created',
      status_code: 201,
      create_date: daysAgoUtc(12, { hour: 9, minute: 30 }),
      msg: 'Invoice successfully created in QuickBooks.',
      target_customer: 'Cedar Peak Media',
      target_type: 'Invoice',
      target_doc_num: 'INV-10391',
      target_doc_id: '138',
      target_status: 'Paid',
      total_amount: '9600.00',
      source_system: 'pipedrive',
      target_system: 'quickbooks',
      object_id: 'pd-deal-2201',
      sent_to_user: true,
      sent_to_customer: true,
      event_data: {
        propertyName: 'status',
        propertyValue: 'won',
        subscriptionType: 'deal.updated',
        changeSource: 'WEB',
        occurredAt: Date.now() - 12 * 24 * 60 * 60 * 1000,
      },
      stream_data: {
        company_data: { name: 'Cedar Peak Media' },
        deal_data: {
          dealname: 'Cedar Peak Multi-year',
          terms: 'Due on receipt',
          payment_method: 'Card',
        },
        inv_data: { hs_number: 'INV-10391' },
        line_items: [
          { name: 'Studio Suite — Year 1', amount: '4800.00' },
          { name: 'Studio Suite — Year 2', amount: '4800.00' },
        ],
      },
    },
    {
      id: 9005,
      event_type: 'Customer Updated',
      status_code: 200,
      create_date: daysAgoUtc(8, { hour: 16, minute: 5 }),
      msg: 'Customer record synced successfully.',
      target_customer: 'Harbor & Co.',
      target_type: 'Customer',
      target_doc_num: null,
      target_doc_id: 'cust-88',
      target_status: 'Active',
      total_amount: null,
      source_system: 'hubspot',
      target_system: 'quickbooks',
      object_id: 'hs-company-991',
      sent_to_user: false,
      sent_to_customer: false,
      event_data: {
        propertyName: 'billing_email',
        propertyValue: 'ap@harbor.co',
        subscriptionType: 'company.propertyChange',
        changeSource: 'IMPORT',
        occurredAt: Date.now() - 8 * 24 * 60 * 60 * 1000,
      },
      stream_data: {
        company_data: { name: 'Harbor & Co.' },
      },
    },
    {
      id: 9006,
      event_type: 'Invoice Created',
      status_code: 500,
      create_date: daysAgoUtc(3, { hour: 13, minute: 55 }),
      msg: 'QuickBooks API returned 500. Please retry.',
      target_customer: 'Summit Analytics',
      target_type: 'Invoice',
      target_doc_num: null,
      total_amount: '3750.00',
      source_system: 'salesforce',
      target_system: 'quickbooks',
      object_id: 'sf-opp-88441',
      sent_to_user: true,
      sent_to_customer: false,
      event_data: {
        propertyName: 'StageName',
        propertyValue: 'Closed Won',
        subscriptionType: 'opportunity.update',
        changeSource: 'API',
        occurredAt: Date.now() - 3 * 24 * 60 * 60 * 1000,
      },
      stream_data: {
        company_data: { name: 'Summit Analytics' },
        deal_data: {
          dealname: 'Summit Growth Package',
          terms: 'Net 45',
        },
        line_items: [
          { name: 'Analytics Bundle', amount: '3750.00' },
        ],
      },
    },
  ];
}

/** Sample invoice queue shaped like `/core/users/feeds/invoices-queue`. */
export function getDummyInvoiceQueue() {
  const items = [
    {
      id: 7001,
      status: 'pending',
      process_type: 'scheduled_invoice',
      future_date: daysFromNowDateOnly(14),
      future_month: null,
      future_year: null,
      term_years: 3,
      create_date: daysAgoUtc(10),
      update_date: daysAgoUtc(1),
      sf_opportunity_id: '006DUMMY0001ABC',
      invoice_data: {
        customer_name: 'Acme Robotics',
        deal_name: 'Acme Annual Platform',
        term_year: 2,
      },
      sf_opportunity: {
        Name: 'Acme Annual Platform',
        Account: { Name: 'Acme Robotics' },
        CloseDate: daysFromNowDateOnly(-40).slice(0, 10),
        Actual_Close_Date__c: daysFromNowDateOnly(-38),
        Term_Years__c: 3,
        Opportunity_Channel__c: 'Direct',
        Billing_Email__c: 'billing@acmerobotics.example',
      },
      line_items: [
        { Description: 'Platform License — Year 2', Amount: '4200.00' },
        { Description: 'Support Plan', Amount: '600.00' },
      ],
    },
    {
      id: 7002,
      status: 'pending',
      process_type: 'scheduled_invoice',
      future_date: daysFromNowDateOnly(45),
      term_years: 3,
      create_date: daysAgoUtc(10),
      update_date: daysAgoUtc(1),
      sf_opportunity_id: '006DUMMY0001ABC',
      invoice_data: {
        customer_name: 'Acme Robotics',
        deal_name: 'Acme Annual Platform',
        term_year: 3,
      },
      sf_opportunity: {
        Name: 'Acme Annual Platform',
        Account: { Name: 'Acme Robotics' },
        CloseDate: daysFromNowDateOnly(-40),
        Term_Years__c: 3,
        Opportunity_Channel__c: 'Direct',
        Billing_Email__c: 'billing@acmerobotics.example',
      },
      line_items: [
        { Description: 'Platform License — Year 3', Amount: '4200.00' },
        { Description: 'Support Plan', Amount: '600.00' },
      ],
    },
    {
      id: 7003,
      status: 'pending',
      process_type: 'scheduled_invoice',
      future_date: daysFromNowDateOnly(7),
      term_years: 2,
      create_date: daysAgoUtc(20),
      update_date: daysAgoUtc(2),
      sf_opportunity_id: '006DUMMY0002DEF',
      invoice_data: {
        customer_name: 'Northwind Labs',
        deal_name: 'Northwind Expansion — Year 2',
        term_year: 2,
      },
      sf_opportunity: {
        Name: 'Northwind Expansion — Year 2',
        Account: { Name: 'Northwind Labs' },
        CloseDate: daysFromNowDateOnly(-60),
        Term_Years__c: 2,
        Opportunity_Channel__c: 'Partner',
        Billing_Email__c: 'ap@northwind.example',
      },
      line_items: [
        { Description: 'Expansion Seat Pack', Amount: '1800.00' },
      ],
    },
    {
      id: 7004,
      status: 'processed',
      process_type: 'scheduled_invoice',
      future_date: daysFromNowDateOnly(-5),
      term_years: 2,
      create_date: daysAgoUtc(40),
      update_date: daysAgoUtc(5),
      sf_opportunity_id: '006DUMMY0003GHI',
      invoice_data: {
        customer_name: 'Cedar Peak Media',
        deal_name: 'Cedar Peak Multi-year',
        term_year: 1,
      },
      sf_opportunity: {
        Name: 'Cedar Peak Multi-year',
        Account: { Name: 'Cedar Peak Media' },
        CloseDate: daysFromNowDateOnly(-100),
        Term_Years__c: 2,
        Opportunity_Channel__c: 'Direct',
        Billing_Email__c: 'finance@cedarpeak.example',
      },
      line_items: [
        { Description: 'Studio Suite — Year 1', Amount: '4800.00' },
      ],
    },
    {
      id: 7005,
      status: 'failed',
      process_type: 'scheduled_invoice',
      future_date: daysFromNowDateOnly(-1),
      term_years: 1,
      create_date: daysAgoUtc(15),
      update_date: daysAgoUtc(1),
      sf_opportunity_id: '006DUMMY0004JKL',
      invoice_data: {
        customer_name: 'Brightside Consulting',
        deal_name: 'Brightside Q3 Renewal',
        term_year: 1,
      },
      sf_opportunity: {
        Name: 'Brightside Q3 Renewal',
        Account: { Name: 'Brightside Consulting' },
        CloseDate: daysFromNowDateOnly(-20),
        Term_Years__c: 1,
        Opportunity_Channel__c: 'Inbound',
        Billing_Email__c: null,
      },
      line_items: [
        { Description: 'Professional Services Retainer', Amount: '2100.00' },
      ],
    },
  ];

  return {
    invoices_queue: items,
    metadata: {
      total_count: items.length,
    },
  };
}
